import React, {useEffect} from 'react';
import './index.scss'
import {Link} from "react-router-dom";
import {buttonEnd} from "../utils/textEndlevel";

interface modalProps{
    openModal:boolean,
    textBodyEnd:string,
    buttonEnd:string,
    id:string | undefined,
    setLevelEnd: React.Dispatch<React.SetStateAction<boolean>>,
    finalPage:boolean,

}
const Modal = (modalProps: modalProps) => {
    const {openModal, textBodyEnd, buttonEnd, id, setLevelEnd, finalPage} = modalProps
    // useEffect(() => {
    //     if (openModal)
    //         document.body.style.overflow = "hidden";
    //     else document.body.style.overflow = "inherit";
    //
    // }, [openModal]);

    const navigate = ()=>{
        if(!finalPage){
            return '/final'
        } else if( id === '2' || id==='4'){
            return `/intermediate/${id}`
        } else {
            return `/game/${Number(id) + 1}`
        }
    }
    return (
        <div className={`modalBg  ${openModal ? 'modalShow' : ""}`}>
            <div className={'positionWrap'}>
           <div className={'modalWrap'}>
               <div className={'modalText'}>
                   {textBodyEnd}
               </div>
            <Link to={navigate()}>
            <button className={'buttonNext'} onClick={()=>{
                setLevelEnd(false)
                // @ts-ignore
                ym(95273517,'reachGoal',`level${id}`)}
            }>
                {buttonEnd}
            </button>
            </Link>
           </div>
            </div>
        </div>
    );
};

export default Modal;
